import { Cart } from '@/types';

export function notifyParentAboutClicks() {
  function handleClick() {
    const clickData = {
      type: 'click',
    };
    window.parent.postMessage(clickData, '*');
  }

  document.addEventListener('click', handleClick);
}

// adapted from https://stackoverflow.com/a/326076/8678845
export function isInIframe () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function watchCartSize() {
  const targetElement = document.querySelector('body');

  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const { contentRect } = entry;

      const resizeData = {
        type: 'resize',
        newWidth: contentRect.width,
        newHeight: contentRect.height,
      };
      window.parent.postMessage(resizeData, '*');
    }
  });

  resizeObserver.observe(targetElement!);
}

export function notifyParentAboutCartChange(cart: Cart) {
  const eventData = {
    type: 'cartChange',
    cart: cart
  };

  window.parent.postMessage(eventData, '*');
}

export function notifyParentAboutUrlChange(newUrl: string) {
  const eventData = {
    type: 'urlChange',
    newUrl
  };

  window.parent.postMessage(eventData, '*');
}
